<template>
  <div>
    <!-- Toolbar da data table -->
    <v-toolbar flat>
      <v-toolbar-title class="font-weight-light">{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="search" label="Pesquisar" single-line hide-details></v-text-field>
      <v-spacer></v-spacer>

      <v-btn :disabled="loading" :loading="loading" :color="loading ? 'info' : 'info'" icon
        title="Inserir um novo registro" @click="addproductCategory();">
        <v-icon>add</v-icon>
      </v-btn>
    </v-toolbar>

    <!-- TABELA -->
    <v-data-table :loading="loading" :headers="headers" :search="search" :items="productCategories" class="elevation-1"
      rows-per-page-text="Registros por Página" :rows-per-page-items="[10, 30, 50, 100]">
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.code }}</td>
        <td class="text-xs-center">{{ props.item.description }}</td>
        <td class="text-xs-center">{{ props.item.type }}</td>
        <td class="text-xs-center">
          <v-chip small class="white--text font-weight-light"
            :color="props.item.active == false ? 'error' : 'success lighten-1' " :disabled="props.item.active == false">
            {{props.item.active == false ? 'Inativo' : 'Ativo'}}</v-chip>
        </td>
        <td class="justify-center layout px-0 text-xs-center">
          <v-btn icon round flat title="Editar" @click="edit(props.item);" color="info" :disabled="loading">
            <v-icon color="info">edit</v-icon>
          </v-btn>
        </td>
      </template>
      <template slot="pageText" slot-scope="props">
        {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
      </template>
      <template slot="no-data">
        <strong> {{footerDynamicText}} </strong>
      </template>
      <div slot="no-results" :value="true">
        <h3 class="text-xs-center">{{emptySearchText}} "{{ search }}".</h3>
      </div>
    </v-data-table>

    <!-- Confirmação de desativação da cidade -->
    <v-dialog v-model="desactivationDialog" persistent :overlay="true" max-width="500px" transition="dialog-transition">
      <v-toolbar class="elevation-1" card>
        <v-toolbar-title class="font-weight-light">
          {{desactivationDialogTitle}}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn color="error" title="Cancelar" icon round flat
            @click.stop.prevent="desactivationDialog = false, productCategory.active = true">
            <v-icon large>clear</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <p>Ao desativar uma categoria você perderá a função de utilizá-la em outras áreas</p>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success lighten-1" block outline round @click="desactivateProductCategory">Aceitar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Insersão Alteração dos dados da cidade -->
    <v-dialog v-model="dialog" persistent class="modal-size" max-width="900px">
      <v-card v-if="loading == false">
        <v-toolbar color="white" class="elevation-1">
          <v-toolbar-title class="black--text font-weight-light">{{formTitle}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-switch class="pt-switch" pt-2 v-if="productCategory && productCategory.active != undefined || null"
              :loading="loading"
              @click.prevent="productCategory.active  == true ? desactivationDialog = true : activateProductCategory()"
              :label='productCategory.active ? "Ativo" : "Inativo"' v-model="productCategory.active"></v-switch>
            <v-btn title="Cancelar" @click="closeDialog" color="error" icon round flat>
              <v-icon large>clear</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-container fluid grid-list-lg>
          <v-card-text>
            <v-form lazy-validation ref="form">
              <v-layout wrap row>
                <v-flex v-if="this.isEditing" xs12>
                  <v-text-field box v-model="productCategory.code" label="Código" disabled></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <p>Tipo - Categoria</p>
                  <v-radio-group v-model="productCategory.type" :rules="typeCategoryRules" row>
                    <v-radio label="Uniforme e EPI's" value="Uniforme e EPI's"></v-radio>
                    <v-radio label="Equipamento" value="Equipamento"></v-radio>
                    <v-radio label="Utensílio" value="Utensílio"></v-radio>
                    <v-radio label="Material de Consumo" value="Material de Consumo"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12>
                  <v-text-field box v-model="productCategory.description" :rules="inputRules" label="Sub-categoria"
                    type="text">
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="success lighten-1" round block :disabled="disabledButtonSave" @click.stop.prevent="save();">
              Salvar</v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" multi-line :timeout="snackbar.timeout" vertical right
      button>
      <strong>{{snackbar.title}}</strong>
      <v-btn dark flat @click="snackbar.visible = false">
        Fechar
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
  import MessageFormatterUtil from '../utils/MessageFormatterUtil.js'
  import ProductCategoryService from "../service/ProductCategoryService.js";
  import UtilFormatter from "../utils/UtilFormatter.js";

  export default {
    data() {
      return {
        productCategories: [],
        productCategoriesOffState: [],
        productCategory: {},
        desactivationDialog: false,
        dialog: false,
        disabledButtonSave: false,
        headers: [{
            text: "Código",
            align: "center",
            value: "code"
          },
          {
            text: "Sub-categoria",
            align: "center",
            value: "description"
          },
          {
            text: "Tipo - Categoria",
            align: "center",
            value: "type"
          },
          {
            text: "Situação",
            align: "center",
            value: "active",
            sortable: false
          },
          {
            text: "Ação",
            align: "center",
            sortable: false
          }
        ],
        loading: false,
        savingProductCategory: false,
        search: "",
        isEditing: false,

        /*********\
          ***Textos**
          \*********/
        desactivationDialogTitle: "Desativar Categoria",
        emptyRecordsText: "Nenhum registro encontrado",

        emptySearchText: "Nenhuma categoria encontrada para",
        footerText: "Total de registros: ",
        loadingRecordsText: "Carregando registros...",
        title: "Categorias de Produtos",
        snackbar: {
          visible: false,
          title: "",
          color: "",
          timeout: 6000
        },

        /**********\
      ***Rules***
      \**********/
        inputRules: [
          v => !!v || 'Campo obrigatório',
        ],
        typeCategoryRules: [
          v => !!v || 'Selecione um tipo'
        ]
      };
    },

    methods: {
      checkDuplicateRecord(category) {
        if (this.productCategories.length > 0) {
          for (const pc of this.productCategories) {
            if (pc.description && pc.description.toUpperCase() == category.description.toUpperCase()) return true;
          }
        }
        return false;
      },
      showSnackbar(message, color) {
        this.snackbar.color = color
        this.snackbar.title = message
        this.snackbar.visible = true
        this.snackbar.timeout = 6000
      }, //showSnackbar()

      closeDialog() {
        this.dialog = false
        this.productCategory = {}
        this.savingProductCategory = false
        this.isEditing = false
      },

      async initialize() {
        if (!this.loading) this.loading = true; //Se não estiver com o visual de carregamento, o ligar
        try {
          if (this.productCategory.length < 1) this.snackbar.visible = false;

          this.productCategories = await ProductCategoryService.getAll(); //Receber os registros da API
          this.productCategory = new Object();
          this.savingProductCategory = false;
          this.search = ""; //Limpar dados
          this.dialog = false;
        } catch (error) {
          //Mandar o erro
          this.showSnackbar("Erro ao carregar as Categorias de Produtos!", "error");
          console.log(error);
        } finally {
          //Tirar o visual de carregamento
          this.loading = false;
        }
      }, //initialize()

      addproductCategory() {
        this.productCategory = new Object();
        this.dialog = true;
      }, //addproductCategory()

      edit(itemSelectEdit) {
        if (this.loading) return;
        this.isEditing = true;
        this.productCategory = itemSelectEdit;
        this.dialog = true;
      }, //edit()
      async activateProductCategory() {
        try {
          this.desactivationDialog = false;
          this.savingProductCategory = true;
          this.productCategory.active = true;
          this.dialog = false;
          await this.save();
          this.showSnackbar("Ativado com sucesso!", "success");
        } catch (error) {
          console.log(error);
        }
      }, //activateProductCategory()
      async desactivateProductCategory() {
        try {
          this.desactivationDialog = false;
          this.productCategory.active = false;
          this.dialog = false;
          await this.save();
          this.showSnackbar("Desativado com sucesso!", "success");
        } catch (error) {
          console.log(error);
        }
      }, //desactivateProductCategory()
      async save() {
        if (this.$refs.form.validate()) {
          if (this.loading) return;

          this.loading = true;

          let errors = ProductCategoryService.validade(this.productCategory)
          if (errors) {
            this.showSnackbar(MessageFormatterUtil.formatErrorMessage(errors), "error")
            this.loading = false
            return
          }

          let msgSnackbar = ""
          let type = ""

          try {
            this.dialog = false;

            if (this.productCategory._id) {
              await ProductCategoryService.update(this.productCategory);
              msgSnackbar = "Categoria de Produto Alterada com Sucesso!";
              type = "success"
            } else {
              if (this.checkDuplicateRecord(this.productCategory)) {
                msgSnackbar = "Registro Duplicado!";
                type = "error"
              } else {
                await ProductCategoryService.save(this.productCategory);
                msgSnackbar = "Categoria de Produto Salva com Sucesso!";
                type = "success"
              }
            }
            this.showSnackbar(msgSnackbar, type);
          } catch (error) {
            this.showSnackbar("Erro ao salvar a Categoria de Produto", "error");
            console.log(error);
          } finally {
            this.isEditing = false;
            this.initialize();
          }
        }

      }, //save()

      updateActivation() {
        console.log("productCategory " + this.productCategory.active);
        console.log("DesativationDialog " + this.desactivationDialog);
        if (this.productCategory.active) this.desactivationDialog = true;
        else this.activateProductCategory();
        //productCategory.active  == true ? desactivationDialog = true : activateProductCategory()
      }
    }, //methods
    computed: {
      formTitle() {
        return this.productCategory._id ?
          "Editar Categoria" :
          "Novo Categoria";
      },
      footerDynamicText() {
        let text = this.loading ? this.loadingRecordsText : this.emptyRecordsText;
        return text;
      }
    }, //computed

    created() {
      this.initialize();
    }, //created()

    watch: {
      dialog(value) {
        value || this.initialize();
      },

      desactivationDialog: function () {
        if (!this.productCategory) return;
        if (!this.productCategory.hasOwnProperty("active")) return;
        if (this.productCategory.active == undefined || null) return;
        if (this.savingProductCategory == true) {
          this.desactivationDialog = false;
        }
      }
    } //watch
  };

</script>
<style lang="css" scoped>
  .pt-switch {
    padding-top: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/ProductCategory.vue